import axiosConfig from '../../axiosConfig';
import axios from 'axios';


export const getProducts = async () => {
    try {
        const response = await axiosConfig.get('/api/products'); // Replace with your API endpoint
        return response.data.products; // Assuming the response structure contains a 'products' array
    } catch (error) {
        if (axios.isCancel(error)) {
            console.warn('Request canceled:', error.message);
        } else {
            console.error('Error fetching products:', error);
        }
        throw error;
    }
};